export default "assets/images/icons/arrow-b1861cb7.svg";